import { Fragment } from 'react';
import { t } from '@ankr.com/common';

import { ChainLabel } from 'modules/chains/components/ChainLabel';
import { PremiumLabel } from 'modules/common/components/GetStartedSection/components/PremiumLabel';
import { SubchainLabels } from 'modules/chains/components/SubchainLabels';
import { ChainUptimeResult } from 'domains/status/utils/calculateChainUptime';

import { ChainStatusTooltip } from '../ChainStatusTooltip';
import { useChainDescriptionStyles } from '../../useChainDescriptionStyles';

interface IChainLabelsProps {
  subchainLabels?: string[];
  isArchive: boolean;
  hasPremiumLabel?: boolean;
  hasFreemiumLabel: boolean;
  isStatusVisible: boolean;
  currentChainStatuses: ChainUptimeResult[];
}

export const ChainLabels = ({
  currentChainStatuses,
  hasFreemiumLabel,
  hasPremiumLabel,
  isArchive,
  isStatusVisible,
  subchainLabels,
}: IChainLabelsProps) => {
  const { classes } = useChainDescriptionStyles();

  const hasChainLabels = subchainLabels && subchainLabels?.length > 0;

  return (
    <>
      {hasChainLabels && (
        <>
          <SubchainLabels Component={Fragment} labels={subchainLabels} />
          {(isArchive || hasPremiumLabel || hasFreemiumLabel) && (
            <div className={classes.dot} />
          )}
        </>
      )}

      {isArchive && (
        <>
          <ChainLabel
            label={t('chains.archive')}
            labelClassName={classes.archiveLabel}
          />
          {(hasPremiumLabel || hasFreemiumLabel || isStatusVisible) && (
            <div className={classes.dot} />
          )}
        </>
      )}

      {hasFreemiumLabel && (
        <>
          <PremiumLabel
            hasFlatBackground
            className={classes.premiumChip}
            preLabel="Freemium"
            label="Premium"
          />
          {isStatusVisible && <div className={classes.dot} />}
        </>
      )}

      {hasPremiumLabel && (
        <>
          <PremiumLabel
            hasFlatBackground
            className={classes.premiumChip}
            label="Premium"
          />
          {isStatusVisible && <div className={classes.dot} />}
        </>
      )}

      {isStatusVisible && (
        <ChainStatusTooltip currentChainStatuses={currentChainStatuses} />
      )}
    </>
  );
};
